"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayReduceNode = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ARRAY-REDUCE';
class ArrayReduceNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap, configFunctions, seedData) => {
            //Function id is in the form <name>::<version>
            const params = await this.asynchronousResolveInputs(nodeMap);
            try {
                const { input, data, initial } = params;
                if (['Sum', 'Max', 'Min'].includes(this.config.functionId)) {
                    const asNumbers = input.map(i => Number(i) || 0);
                    if (!asNumbers.length) {
                        return { reduced: 0 };
                    }
                    if (this.config.functionId === 'Sum') {
                        return { reduced: asNumbers.reduce((prev, val) => val + prev, 0) };
                    }
                    if (this.config.functionId === 'Max') {
                        return { reduced: Math.max(...asNumbers) };
                    }
                    if (this.config.functionId === 'Min') {
                        return { reduced: Math.min(...asNumbers) };
                    }
                }
                let reduced = initial;
                const [functionName, versionString] = this.config.functionId.split('::');
                const map = lodash_1.default.find(configFunctions[functionName].versions, { versionNumber: +versionString }).aggregateMap;
                const { inputName, outputName, inputArrayName, inputIndexName, inputData } = this.config;
                for (let i = 0; i < input.length; i++) {
                    const item = input[i];
                    const p = {
                        prev: reduced,
                    };
                    p[inputName] = item;
                    if (inputArrayName) {
                        p[inputArrayName] = input;
                    }
                    if (inputIndexName) {
                        p[inputIndexName] = i;
                    }
                    if (inputData) {
                        p.data = data;
                    }
                    reduced = (await this.mapScenarios.FUNCTION_MAPPING.evaluate(map, Object.assign(Object.assign({}, this.accessorMap), { DATA: () => p }), configFunctions, seedData === null || seedData === void 0 ? void 0 : seedData.timestamp, (seedData === null || seedData === void 0 ? void 0 : seedData.parentNodeId) + '-' + i))[outputName];
                }
                return {
                    reduced: reduced,
                };
            }
            catch (e) {
                console.error('ArrayReduce error: ', e.errorMessage);
                return null;
            }
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Array reduce is not allowed as a synchronously resolving node');
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        this.config.type = this.config.type || 'Number';
        const schemas = this.schemaLookup.getFunctions().map(schema => schema.schemaId).sort((a, b) => a.toLocaleLowerCase() > b.toLocaleLowerCase() ? 1 : -1);
        const options = [];
        if (this.config.type === 'Number') {
            options.push('Sum', 'Max', 'Min');
        }
        lodash_1.default.each(schemas, item => {
            const outputParams = this.schemaLookup.getFunctionOutput(item);
            const outputName = Object.keys(outputParams.properties).length === 1 ? Object.keys(outputParams.properties)[0] : null;
            if (outputName) {
                const outputType = outputParams.properties[outputName].type;
                const inputParams = this.schemaLookup.getFunctionInput(item);
                const prev = inputParams.properties['prev'];
                if (!prev || prev.type !== outputType) {
                    return;
                }
                const inputData = inputParams.properties['data'] ? true : false;
                const extra = inputData ? 2 : 1;
                //Get functions with the signature of (<selectedType>) => bool
                let inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 1 + extra, [
                    'data',
                    'prev',
                    'initial',
                ]);
                if (inputName) {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = undefined;
                        this.config.inputIndexName = undefined;
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //Get functions with the signature of (<selectedType>, <selectedType>[]) => bool
                inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 2 + extra, ['data', 'prev', 'initial']);
                let inputArrayName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type + ' Array', inputParams, 2 + extra, [
                    'data',
                    'prev',
                    'initial',
                ]);
                if (inputArrayName && inputName) {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = inputArrayName;
                        this.config.inputIndexName = undefined;
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //Get functions with the signature of (<selectedType>, <selectedType>[], index:number) => bool
                inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 3 + extra, [
                    'index',
                    'data',
                    'prev',
                    'initial',
                ]);
                inputArrayName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type + ' Array', inputParams, 3 + extra, [
                    'data',
                    'prev',
                    'initial',
                ]);
                const inputIndexName = BaseNode_1.BaseNode.schemaMatchesType('Number', inputParams, 3 + extra, [
                    inputName,
                    'data',
                    'prev',
                    'initial',
                ]);
                if (inputArrayName && inputArrayName && inputIndexName === 'index') {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = inputArrayName;
                        this.config.inputIndexName = 'index';
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //If we reach this point and the selected function id matches the current function,
                //the selected type must have changed, so the previously selected function is invalid, so clear config properties
                if (item === this.config.functionId) {
                    this.config.inputName = undefined;
                    this.config.outputName = undefined;
                    this.config.inputArrayName = undefined;
                    this.config.inputIndexName = undefined;
                    this.config.inputData = undefined;
                }
            }
        });
        if (['Sum', 'Max', 'Min'].includes(this.config.functionId)) {
            this.config.inputName = undefined;
            this.config.outputName = undefined;
            this.config.inputArrayName = undefined;
            this.config.inputIndexName = undefined;
            this.config.inputData = undefined;
        }
        const OutputParams = ['Sum', 'Max', 'Min'].includes(this.config.functionId)
            ? {
                type: 'object',
                properties: {
                    reduced: {
                        type: 'number',
                        title: this.config.functionId,
                    },
                },
            }
            : this.config.outputName && this.config.functionId
                ? {
                    type: 'object',
                    properties: {
                        reduced: this.schemaLookup.getFunctionOutput(this.config.functionId).properties[this.config.outputName],
                    },
                }
                : {};
        const InputParams = {
            type: 'object',
            properties: {
                input: {
                    items: this.config.inputName && this.config.functionId //If we have a selected config, pull the exact schema for the input - this is helpful for objects so their properties can be shown.
                        ? Object.assign(Object.assign({}, this.schemaLookup.getFunctionInput(this.config.functionId).properties[this.config.inputName]), { description: 'Item' }) : BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Items to Reduce',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        if (this.config.inputData) {
            InputParams.properties['data'] = this.schemaLookup.getFunctionInput(this.config.functionId).properties['data'];
        }
        if (this.config.outputName && this.config.functionId) {
            InputParams.properties['initial'] = this.schemaLookup.getFunctionOutput(this.config.functionId).properties[this.config.outputName];
        }
        const ConfigParams = {
            type: 'object',
            properties: {
                type: BaseNode_1.BaseNode.getTypeOptions(false),
                functionId: {
                    description: 'Reducer Function',
                    type: 'string',
                    enum: options,
                },
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: ConfigParams });
    }
}
exports.ArrayReduceNode = ArrayReduceNode;
ArrayReduceNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Array Reduce',
    isIdempotent: false,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ArrayReduce.js.map